<button mat-icon-button (click)="onBookmark()">
  <mat-icon *ngIf="!isActive" style="color: #999999;">bookmark_border</mat-icon>
  <mat-icon *ngIf="isActive">bookmark</mat-icon>
</button>
